import config from '~/config';
import http from './http';

export const getMortgageClauses = async () => {
    try {
        const results = await http.get(`${config.urls.base}/mortgageClause`);
        if (results.errored) {
            throw new Error(results.error);
        }

        return results;

    } catch (err) {
        console.error(err);
        return [];
    }
};

export default {
    getMortgageClauses
};